/**
 * ExitTile - Level exit (requires all stars to be collected)
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export class ExitTile extends BaseTile {
  constructor({ col, row, id }: { col: number; row: number; id?: string }) {
    super(id ?? `exit-${col}-${row}`, col, row);
  }

  tileType(): TileIndex {
    return TILE.EXIT;
  }

  textureDescriptor(): TextureDescriptor {
    return { type: "png", path: "tiles/exit.png" };
  }

  clone(): ExitTile {
    const copy = new ExitTile({ col: this.col, row: this.row, id: this.id });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return { type: "exit", id: this.id, col: this.col, row: this.row };
  }
}
